module.exports = __webpack_public_path__ + "static/sport/banner7.6529745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner7.png
// module id = /BGF
// module chunks = 0